(function() {
  define('commons/reachCharts',["jquery", "commons/chartServices"], function($, chartServices) {
    var executeDigital, executePrint;
    executeDigital = function(uri, chartId, hideTertialsHighlight) {
      var createChart, highlightTertialsInTable;
      createChart = function(uri, chartId) {
        var populateData;
        $.ajax({
          url: $(uri).val(),
          dataType: "jsonp"
        }).done((function(_this) {
          return function(resp) {
            var data, dataPoints;
            dataPoints = [];
            dataPoints.push(resp.reachMonthDataPoints);
            dataPoints.push(resp.reachTertialDataPoints);
            data = populateData(dataPoints, 100, 0);
            data.chartSettings.tooltip = {
              shared: true,
              useHTML: true,
              headerFormat: "",
              pointFormat: "<table> <tr> <td> <h4><strong>{point.y}</strong></h4> </td> </tr> <tr> <td> {point.source} </td> </tr> </table>"
            };
            return chartServices.renderSplineChart(chartId, data.series, data.chartSettings);
          };
        })(this));
        return populateData = function(series, tickInterval, min) {
          var chartSettings, data, dataValue, date, endDates, highestValue, highlightEndDate, highlightStartDate, i, item, j, k, len, len1, s, selectedPeriod, startDates, utcDate;
          highestValue = Math.max.apply(null, _.map(series[0], "value"));
          selectedPeriod = _.filter(series[1], function(data) {
            return data.isSelected;
          });
          startDates = [];
          _.forEach(_.map(selectedPeriod, "surveyPeriodFrom"), (function(_this) {
            return function(date) {
              return startDates.push(new Date(date));
            };
          })(this));
          endDates = [];
          _.forEach(_.map(selectedPeriod, "surveyPeriodTo"), (function(_this) {
            return function(date) {
              return endDates.push(new Date(date));
            };
          })(this));
          if (hideTertialsHighlight === void 0 && selectedPeriod.length > 0) {
            highlightStartDate = Math.min.apply(null, startDates);
            highlightEndDate = Math.max.apply(null, endDates);
            $(".card-nav").removeClass("hide");
          } else if (hideTertialsHighlight === true || selectedPeriod.length === 0) {
            highlightStartDate = null;
            highlightEndDate = null;
          }
          chartSettings = {
            xAxis: {
              tickmarkPlacement: "on",
              type: "datetime",
              plotBands: [
                {
                  from: highlightStartDate,
                  to: highlightEndDate,
                  color: "rgba(68, 170, 213, .2)"
                }
              ]
            },
            yAxis: {
              title: '',
              text: '',
              tickAmount: 3,
              max: highestValue,
              softMax: highestValue
            }
          };
          item = {
            chartSettings: chartSettings,
            series: [
              {
                name: "R�ckvidd",
                data: []
              }, {
                type: "spline",
                name: "Tertial",
                data: []
              }
            ]
          };
          i = 0;
          for (j = 0, len = series.length; j < len; j++) {
            data = series[j];
            for (k = 0, len1 = data.length; k < len1; k++) {
              s = data[k];
              date = new Date(s.date);
              utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
              dataValue = {
                x: utcDate,
                y: s.value,
                source: s.source != null ? s.source : "Tertial",
                mediaName: s.mediaName
              };
              item.series[i].data.push(dataValue);
            }
            i++;
          }
          return item;
        };
      };
      $(".chg-chart").click(function(event) {
        var t, tertial;
        tertial = $(this).attr("href");
        t = tertial.replace("#", "");
        $(uri).val($(uri).val().substr(0, $(uri).val().indexOf("selectedPeriod=")) + "selectedPeriod=" + t);
        highlightTertialsInTable(tertial, this);
        return createChart(uri, chartId);
      });
      highlightTertialsInTable = function(tertial, element) {
        $(".data").removeClass("active");
        $(".data").each(function() {
          var range;
          range = $(this).data("range");
          if (tertial === range) {
            $(this).addClass("active");
          }
          if (tertial === "#H") {
            if (range === "#H1" || range === "#T2" || range === "#T3") {
              return $(this).addClass("active");
            }
          }
        });
        if (element != null) {
          $(".card-nav li").removeClass("active");
          return $(element).parent("li").addClass("active");
        }
      };
      createChart(uri, chartId);
      return highlightTertialsInTable("#T1");
    };
    executePrint = function(uri, chartId) {
      var createChart, populateData;
      createChart = function(uri, chartId) {
        return $.ajax({
          url: $(uri).val(),
          dataType: "jsonp"
        }).done((function(_this) {
          return function(resp) {
            var data, dataPoints, filteredYearDataPoints, tertialStartDate;
            dataPoints = [];
            if (resp.reachTertialDataPoints === null || resp.reachTertialDataPoints.length === 0) {
              dataPoints.push([]);
              dataPoints.push(resp.reachYearDataPoints);
            } else {
              dataPoints.push(resp.reachTertialDataPoints);
              tertialStartDate = _.min(_.map(resp.reachTertialDataPoints, function(x) {
                return new Date(x.date);
              }));
              filteredYearDataPoints = _.filter(resp.reachYearDataPoints, function(x) {
                return (new Date(x.date)).getFullYear() >= tertialStartDate.getFullYear();
              });
              dataPoints.push(filteredYearDataPoints);
            }
            data = populateData(dataPoints, 100, 0);
            data.chartSettings.tooltip = {
              shared: false,
              useHTML: true,
              headerFormat: "",
              pointFormat: "<table> <tr> <td> <h4><strong>{point.y}</strong></h4> </td> </tr> <tr> <td> {point.source} </td> </tr> </table>"
            };
            return chartServices.renderSplineChart(chartId, data.series, data.chartSettings);
          };
        })(this));
      };
      populateData = function(series, tickInterval, min) {
        var chartSettings, data, dataValue, date, h1, h2, highestValue, i, item, j, k, len, len1, s, utcDate;
        h1 = Math.max.apply(null, _.map(series[0], "value"));
        h2 = Math.max.apply(null, _.map(series[1], "value"));
        if (h2 > h1) {
          highestValue = h2;
        } else {
          highestValue = h1;
        }
        chartSettings = {
          xAxis: {
            type: "datetime"
          },
          yAxis: {
            title: "",
            text: "",
            tickAmount: 3,
            max: highestValue,
            softMax: highestValue
          }
        };
        item = {
          chartSettings: chartSettings,
          series: [
            {
              name: "R�ckvidd",
              data: [],
              point: {
                events: {
                  click: function() {}
                }
              }
            }, {
              type: "spline",
              name: "Hel�r",
              data: []
            }
          ]
        };
        i = 0;
        for (j = 0, len = series.length; j < len; j++) {
          data = series[j];
          for (k = 0, len1 = data.length; k < len1; k++) {
            s = data[k];
            date = new Date(s.date);
            utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
            dataValue = {
              x: utcDate,
              y: s.value,
              source: s.source != null ? s.source : "Tertial",
              mediaName: s.mediaName
            };
            item.series[i].data.push(dataValue);
          }
          i++;
        }
        return item;
      };
      return createChart(uri, chartId);
    };
    return {
      executeDigital: executeDigital,
      executePrint: executePrint
    };
  });

}).call(this);

//# sourceMappingURL=reachCharts.js.map
;
